// src/index.ts
import { ParachainId } from "@zenlink-interface/chain";
var ZENLINK_ENABLED_NETWORKS = [
  ParachainId.MOONBEAM,
  ParachainId.MOONRIVER,
  ParachainId.ASTAR,
  ParachainId.BIFROST_KUSAMA,
  ParachainId.BIFROST_POLKADOT
];
var SQUID_HOST_ENDPOINT = "https://squid.subsquid.io";
var SQUID_HOST = {
  [ParachainId.ASTAR]: `${SQUID_HOST_ENDPOINT}/Zenlink-Astar-Squid/graphql`,
  [ParachainId.MOONRIVER]: `${SQUID_HOST_ENDPOINT}/Zenlink-Moonriver-Squid/graphql`,
  [ParachainId.MOONBEAM]: `${SQUID_HOST_ENDPOINT}/Zenlink-Moonbeam-Squid/graphql`,
  [ParachainId.BIFROST_KUSAMA]: `${SQUID_HOST_ENDPOINT}/zenlink-bifrost-kusama-squid/graphql`,
  [ParachainId.BIFROST_POLKADOT]: `${SQUID_HOST_ENDPOINT}/zenlink-bifrost-polkadot-squid/graphql`
};
var ARCHIVE_HOST = {
  [ParachainId.BIFROST_KUSAMA]: "https://bifrost.explorer.subsquid.io/graphql"
};
export {
  ARCHIVE_HOST,
  SQUID_HOST,
  SQUID_HOST_ENDPOINT,
  ZENLINK_ENABLED_NETWORKS
};
